<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="option_breadcrumb" />
    </div>

    <div class="header">
      <h1 class="overlay">OPTION PROGRAM</h1>
      <!--      <img src="@/assets/images/Podohotel/hotspring_headerimage.jpg" />-->
      <div class="headerimage" />
    </div>

    <div class="container">
      <div class="row d-flex justify-content-center">
        <!--        <div>-->
        <!--          <img src="@/assets/images/pleisure/pleisure_headerimage.jpg" />-->
        <!--        </div>-->
        <div class="col-lg-12 rowSpace"></div>
        <div class="text-center col-lg-12 mainTitle">{{ $t('shooting_title') }}</div>
        <div class="mainTitleLine">
          <hr />
        </div>
        <div class="col-lg-12 text-center mainIntro">{{ $t('shooting_subtitle') }}</div>
        <div class="rowSpace"></div>
        <div class="col buttonArea">
          <button class="prev-button" @click="$router.go(-1)">{{ $t('prev_button') }}</button>
        </div>
        <div class="rowSpace"><hr /></div>
        <GallerySlideCarousels :slides="main_slides" :slide-count="4" :thumb-slide-width="45" />
      </div>
    </div>
    <div class="container subContainer">
      <div class="row d-flex justify-content-center">
        <div class="col-lg-12 mainInfo">
          <table class="col-lg-12 table table-bordered infoTable">
            <tbody>
              <tr>
                <td class="tHead">{{ $t('shooting_table1_tr1_td1') }}</td>
                <td class="tBody" v-html="$t('shooting_table1_tr1_td2')"></td>
              </tr>
              <tr>
                <td class="tHead">{{ $t('shooting_table1_tr2_td1') }}</td>
                <td class="tBody" v-html="$t('shooting_table1_tr2_td2')"></td>
              </tr>
              <tr>
                <td class="tHead">{{ $t('shooting_table1_tr3_td1') }}</td>
                <td class="tBody" v-html="$t('shooting_table1_tr3_td2')"></td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('shooting_table1_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('shooting_program_title') }}</div>

          <table class="col-lg-12 table table-bordered subTable">
            <thead>
              <tr>
                <td style="width: 40%">{{ $t('shooting_table2_tr1_td1') }}</td>
                <td style="width: 30%">{{ $t('shooting_table2_tr1_td2') }}</td>
                <td style="width: 30%">{{ $t('shooting_table2_tr1_td3') }}</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ $t('shooting_table2_tr2_td1') }}</td>
                <td>{{ $t('shooting_table2_tr2_td2') }}</td>
                <td>{{ $t('shooting_table2_tr2_td3') }}</td>
              </tr>
            </tbody>
          </table>
          <div class="etcDetail">{{ $t('shooting_table2_desc') }}</div>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('shooting_combi_title') }}</div>
          <ol>
            <li>{{ $t('shooting_combi_desc1') }}</li>
            <li>{{ $t('shooting_combi_desc2') }}</li>
            <li>{{ $t('shooting_combi_desc3') }}</li>
            <li>{{ $t('shooting_combi_desc4') }}</li>
            <li>{{ $t('shooting_combi_desc5') }}</li>
            <li>{{ $t('shooting_combi_desc6') }}</li>
          </ol>
        </div>
        <div class="rowSpace"><hr /></div>
        <div class="col-lg-12 serviceArea">
          <div class="subTitle">{{ $t('shooting_reserve_title') }}</div>
          <ol>
            <li>{{ $injectEmails($t('shooting_reserve_desc1')) }}</li>
            <li>{{ $t('shooting_reserve_desc2') }}</li>
          </ol>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import GallerySlideCarousels from '@/components/GallerySlideCarousels';

export default {
  name: 'Shooting',
  data() {
    return {
      isLang: 0,
      option_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      main_slides: [
        {image: require('@/assets/images/pleisure/option/shooting_01.jpg')},
        {image: require('@/assets/images/pleisure/option/shooting_02.jpg')},
        {image: require('@/assets/images/pleisure/option/shooting_03.jpg')},
        {image: require('@/assets/images/pleisure/option/shooting_04.jpg')},
      ],
    };
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  created() {
    this.refreshLocale(this.$i18n.locale);
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }
      this.program_breadcrumb = {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      };

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  components: {Breadcrumb, GallerySlideCarousels},
};
</script>

<style scoped lang="scss">
td {
  vertical-align: middle;
}
li {
  list-style-type: square;
  font-size: 0.9rem;
}

.header {
  position: relative;
  width: 100%;
  > img {
    width: 100%;
  }

  .overlay {
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }
}
.mainTitle {
  font-weight: 800;
  font-size: 2rem;
  letter-spacing: -0.1rem;
}
.mainTitleLine {
  width: 10%;
  > hr {
  }
}
.mainIntro {
  word-break: keep-all;
}
.buttonArea {
  width: 100%;
  display: flex;
  justify-content: space-between;
  .resserve-button {
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: #524a3d;
    color: #fff;
  }
  .prev-button {
    justify-content: center;
    width: 8rem;
    height: 3rem;
    text-align: center;
    line-height: 3rem;
    background-color: white;
    color: #000;
    border: 1px solid black;
  }
}
.subContainer {
  width: 100%;
}
.mainInfo {
  padding: 1rem;
  width: 100%;
  height: 100%;
  line-height: 1.5rem;
  font-size: 1rem;
}
.serviceArea {
  padding: 1rem;
  > span {
    font-size: 0.8rem;
  }
}
.subTitle {
  font-weight: 600;
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}
.subDetail {
  font-size: 0.9rem;
  padding-left: 1rem;
  word-break: keep-all;
}
.etcDetail {
  font-size: 0.8rem;
  padding-left: 1rem;
  color: #616161;
}
.subTable {
  > thead {
    background-color: #eaeaea;

    > tr > td {
      width: 50%;
      text-align: center;
      font-weight: 600;
    }
  }
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  margin-bottom: 0.5rem;
}
.infoTable {
  > tbody {
    > tr > td {
      text-align: center;
      font-size: 0.9rem;
    }
  }
  .tHead {
    text-align: center;
    font-weight: bold;
    font-size: 0.9rem;
  }
  .tBody {
    text-align: center;
    font-size: 0.9rem;
  }
  margin-bottom: 0.5rem;
}

.rowSpace {
  width: 100%;
  height: 2rem;
  > hr {
  }
}

@media (min-width: 992px) {
  .headerimage {
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/common/option_headerimage.jpg');
  }
  .web {
    display: block;
  }
  .mobile {
    display: none;
  }
  .tHeader {
    font-size: 1.1rem;
  }
  .tBody {
    font-size: 1rem;
  }
}
@media (max-width: 992px) {
  .headerimage {
  }
  .header {
    position: relative;
    width: 100%;
    padding-top: 5rem;
    > img {
      width: 100%;
    }

    .overlay {
      padding-top: 5rem;
      color: White;
      position: absolute;
      text-align: center;
      z-index: 12;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-weight: bold;
    }
  }
  .headerimage {
    display: none;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "옵션 프로그램",
    "shooting_title": "사격",
    "shooting_subtitle": "권총, 소총, 클레이 사격 3종을 안전하고 손쉽게 체험할 수 있는 이색 레저 프로그램",
    "prev_button": "이전",
    "shooting_table1_tr1_td1":"권총 사격",
    "shooting_table1_tr1_td2":"휴대가 편리하기 때문에 주로 경찰용 총기로 많이 사용되었으나,<br/>다소 육중한 굉음을 내며 격발하여 온 몸으로 소리와 스릴을 느낄 수 있는 레저 스포츠 입니다.",
    "shooting_table1_tr2_td1":"소총(라이플) 사격",
    "shooting_table1_tr2_td2":"실탄을 사용하며 멀리 있는 표적도 정확하게 명중시킬 수 있는 능력을 이용한 스포츠로,<br/>정적인 물체를 표적으로 하기 때문에 명중률이 좋아 초보자도 쉽게 이용 가능합니다.",
    "shooting_table1_tr3_td1":"클레이 사격",
    "shooting_table1_tr3_td2":"공중으로 떠오른 진흙 접시를 산탄총으로 쏘아 맞추는 레저 스포츠로<br/>집중력, 결단력, 자제력, 민첩성을 기르는데 큰 효과가 있습니다.",
    "shooting_table1_desc": "※ 연령제한 : 만 17세 이상",
    "shooting_program_title": "운영 프로그램",
    "shooting_table2_tr1_td1": "프로그램",
    "shooting_table2_tr1_td2": "옵션",
    "shooting_table2_tr1_td3": "요금(2인 기준)",
    "shooting_table2_tr2_td1": "권총, 소총, 클레이사격 3종",
    "shooting_table2_tr2_td2": "-",
    "shooting_table2_tr2_td3": "150,000 ~",
    "shooting_table2_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "shooting_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "shooting_combi_desc1": "프라이빗 럭셔리요트",
    "shooting_combi_desc2": "챌린저 골프",
    "shooting_combi_desc3": "노블승마",
    "shooting_combi_desc4": "제주어부",
    "shooting_combi_desc5": "해피투게더",
    "shooting_combi_desc6": "제주 숲토리텔링 투어",
    "shooting_reserve_title": "예약문의 및 상담",
    "shooting_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "shooting_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  },
  "en": {
    "breadcrumb": "Option Program",
    "shooting_title": "Shooting",
    "shooting_subtitle": "A unique leisure program you can have shooting experience of 3 types of guns (pistol, rifle, and clay shooting) safely and easily.",
    "prev_button": "Previous",
    "shooting_table1_tr1_td1":"Shooting pistol",
    "shooting_table1_tr1_td2":"It was mainly used by police officers because it is convenient to carry,<br/>but it is also used for the leisure sport because you can feel the sound and thrill due to its heavy booming sound.",
    "shooting_table1_tr2_td1":"Rifle shooting",
    "shooting_table1_tr2_td2":"It is a sport of shooting distant targets accurately with live ammunition.<br/>It has a high accuracy rate as targeting static objects, making it easy for beginners to enjoy.",
    "shooting_table1_tr3_td1":"Clay shooting",
    "shooting_table1_tr3_td2":"It is a leisure sport that shoots mud plates in the air with a shotgun,<br/>which is highly effective on improving concentration, determination, self-control, and agility.",
    "shooting_table1_desc": "※ Available only for 17 years old or older",
    "shooting_program_title": "Program",
    "shooting_table2_tr1_td1": "Program",
    "shooting_table2_tr1_td2": "Option",
    "shooting_table2_tr1_td3": "Fare*(2 people)",
    "shooting_table2_tr2_td1": "Pistol, Rifle, Clay shooting",
    "shooting_table2_tr2_td2": "-",
    "shooting_table2_tr2_td3": "KRW 150,000 ~",
    "shooting_table2_desc": "※ Special price for P-Leisure users",
    "shooting_combi_title": "Combinable programs",
    "shooting_combi_desc1": "private luxury yacht",
    "shooting_combi_desc2": "challenger golf",
    "shooting_combi_desc3": "noble riding",
    "shooting_combi_desc4": "Jeju fisherman",
    "shooting_combi_desc5": "Happytogether",
    "shooting_combi_desc6": "Jeju forest-ory tour",
    "shooting_reserve_title": "Reservation",
    "shooting_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "shooting_reserve_desc2": "MON~Sun (Excluding public holidays) 09:00 ~17:30 (Lunch 12:00 ~13:00)"
  },
  "ja": {
    "breadcrumb": "옵션 프로그램",
    "shooting_title": "사격",
    "shooting_subtitle": "권총, 소총, 클레이 사격 3종을 안전하고 손쉽게 체험할 수 있는 이색 레저 프로그램",
    "prev_button": "이전",
    "shooting_table1_tr1_td1":"권총 사격",
    "shooting_table1_tr1_td2":"휴대가 편리하기 때문에 주로 경찰용 총기로 많이 사용되었으나,<br/>다소 육중한 굉음을 내며 격발하여 온 몸으로 소리와 스릴을 느낄 수 있는 레저 스포츠 입니다.",
    "shooting_table1_tr2_td1":"소총(라이플) 사격",
    "shooting_table1_tr2_td2":"실탄을 사용하며 멀리 있는 표적도 정확하게 명중시킬 수 있는 능력을 이용한 스포츠로,<br/>정적인 물체를 표적으로 하기 때문에 명중률이 좋아 초보자도 쉽게 이용 가능합니다.",
    "shooting_table1_tr3_td1":"클레이 사격",
    "shooting_table1_tr3_td2":"공중으로 떠오른 진흙 접시를 산탄총으로 쏘아 맞추는 레저 스포츠로<br/>집중력, 결단력, 자제력, 민첩성을 기르는데 큰 효과가 있습니다.",
    "shooting_table1_desc": "※ 연령제한 : 만 17세 이상",
    "shooting_program_title": "운영 프로그램",
    "shooting_table2_tr1_td1": "프로그램",
    "shooting_table2_tr1_td2": "옵션",
    "shooting_table2_tr1_td3": "요금(2인 기준)",
    "shooting_table2_tr2_td1": "권총, 소총, 클레이사격 3종",
    "shooting_table2_tr2_td2": "-",
    "shooting_table2_tr2_td3": "150,000 ~",
    "shooting_table_desc": "※ P-Leisure 메인프로그램 이용 시 적용되는 특별가 입니다.",
    "shooting_combi_title": "결합 가능한 P-Leisure 메인 프로그램",
    "shooting_combi_desc1": "프라이빗 럭셔리요트",
    "shooting_combi_desc2": "챌린저 골프",
    "shooting_combi_desc3": "노블승마",
    "shooting_combi_desc4": "제주어부",
    "shooting_combi_desc5": "해피투게더",
    "shooting_combi_desc6": "제주 숲토리텔링 투어",
    "shooting_reserve_title": "예약문의 및 상담",
    "shooting_reserve_desc1": "064-793-7070, 010-5328-7050, [[EMAIL:leisure]]",
    "shooting_reserve_desc2": "월~금(공휴일 제외) 09:00 ~ 17:30 (점심시간 12:00 ~ 13:00)"
  }
}
</i18n>
